import { PrivateInterceptor } from "../../Base/interceptors/PrivateInterceptor";

// OBTIENE LOS PROVEEDORES ACTIVOS
export const getProveedoresActivos = async () => {
    const response = await PrivateInterceptor('proveedores/proveedoresActivos', 'GET');
    return response;
};

